import tw from 'twin.macro';
import styled from 'styled-components';

export const VideoContainer = styled.div`
  ${tw`relative w-full h-screen mt-0 overflow-hidden flex items-center`}
  padding: 100px 20px;
`;

export const VideoBackground = styled.video`
  ${tw`absolute top-0 left-0 w-full h-full object-cover`}
  filter: grayscale(0%);
`;


export const Content = styled.div`
  ${tw`relative z-10 text-white p-5 ml-24`}
`;

export const Heading = styled.h1`
  ${tw`text-6xl font-serif`}
  font-family: 'Cantata One', serif;
`;

export const Paragraph = styled.p`
  ${tw`uppercase mb-2 tracking-widest`}
`;

export const LinkButton = styled.a`
  ${tw`text-white no-underline border-b-2 border-white text-lg inline-block mt-5 pb-1 relative transition-all duration-300 ease-in-out`}
  
  &:hover {
    ${tw`border-black`}
    
    &:after {
      width: 100%;
    }
  }

  &:after {
    ${tw` absolute h-0.5 w-0 bottom-0 left-0 transition-all duration-300 ease-in-out`}
  }
`;
